import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    rmPedidos:[],
    menu:[]
  },
  mutations: {
    setMenu(state, menu){
      state.menu = menu
    },
    setClearMenu(state){
      state.menu = []
    },

    setPedidos(state, pedidos){
      state.rmPedidos = pedidos
    },
    setEstatus(state, datos){
      for (let i = 0; i < state.rmPedidos.length; i++) {
        const pd = state.rmPedidos[i];
        if(pd.serie == datos.serie && pd.num == datos.num && pd.par == datos.par){          
          state.rmPedidos[i].estatus = datos.estatus
        } 
      }        
    },
    setClear(state){
      state.rmPedidos = []
    }
  },
  actions: {
  },
  modules: {
  },
  getters:{
    rmPedidos(state){
      return state.rmPedidos
    },

    menu(state){
      return state.menu
    }

  }
})
